
export default class Utils{

    months = ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"];
    
    static getFullMonths(){
        const fullNameMonths = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];
        return fullNameMonths;
    }

    static addMonths(date, months) {
        let copiedDate = new Date(date.getTime());
        copiedDate.setMonth(date.getMonth() + months);
      
        return copiedDate;
    }
    static subMonths(date, months) {
        let copiedDate = new Date(date.getTime());
        copiedDate.setMonth(date.getMonth() - months);
      
        return copiedDate;
    }

    getLastDayOfMonth(year, month) {
        let lastDay =  new Date(year, month + 1, 0);
        lastDay.setHours(0,0,0,0);
        return lastDay;
    }


    checkBetweenDates(dateCheck, dateFrom, dateTo)
    {
        // var dateFrom = "02/05/2013";
        // var dateTo = "02/09/2013";
        // var dateCheck = "02/07/2013";

        var d1 = dateFrom.split("/");
        var d2 = dateTo.split("/");
        var c = dateCheck.split("/");

        var from = new Date(d1[2], parseInt(d1[1])-1, d1[0]);  // -1 because months are from 0 to 11
        var to   = new Date(d2[2], parseInt(d2[1])-1, d2[0]);
        var check = new Date(c[2], parseInt(c[1])-1, c[0]);

        console.log(check > from && check < to)
    }

    static arrayWord(word, firstSplit = 4, secondSplit = 3)
    {
        let respo = ["", ""];
        let splitIndex = firstSplit;
        word.split(" ").forEach((wrd, index) => {
            if(respo[0].length > 20)
                splitIndex = secondSplit;
            if(index < splitIndex)
                respo[0] += wrd+" ";
            else
                respo[1] += wrd+" ";
        });
        if(respo[1] == "")
            respo.pop();
        
        return respo;
    }

    static arrayWord2(word, firstSplit = 4, secondSplit = 3)
    {
        let respo = ["", "", ""];
        let splitIndex = firstSplit;
        word.split(" ").forEach((wrd, index) => {
            if(respo[0].length > 20)
                splitIndex = secondSplit;

            if(index < splitIndex)
                respo[0] += wrd+" ";
            else if(respo[1].length < 20)
                respo[1] += wrd+" ";
            else
                respo[2] += wrd +" "
        });
        if(respo[1] == "")
            respo.pop();
        
        return respo;
    }



    /**
     * Returns a 2 digit number always 
     * @param {string} num a number 
     */
    alwaysTwoDigits(num)
    {
        if(num.toString().length == 1)
            return `0${num}`;
        return num;
    }

    halfMonthsYear(year){
        //console.log//(new Date(`${year}-1-1`), "yearrr")
        let start = new Date(`${year}-1-1`);
        start.setHours(0,0,0,0);
        let end = new Date(`${year}-12-31`);
        end.setHours(0,0,0,0)

        let now = new Date();
        now.setHours(0,0,0,0)
        let broke = false;
        const weeks = [];
        let current = start;
        let valueStart = null;
        let valueEnd = null;
        let active = false;
        //console.log(current.getDate(), "curerent", start)
        while (!broke) {
            
            //first month day
            if(current.getDate() == 1){
                // let weekText = `${this.alwaysTwoDigits(current.getDate())}/${this.months[current.getMonth()]}`;
                let weekText = this.dateFormatLocal(current);
                valueStart = current;
                current = current.addDays(14);
                // weekText += ` - ${this.alwaysTwoDigits(current.getDate())}/${this.months[current.getMonth()]}`;
                weekText += ` - ${this.dateFormatLocal(current)}`;
                valueEnd = current;

                if(now >= valueStart && now <= valueEnd)
                    active = true;
                
                valueStart = `${valueStart.toISOString().split("T")[0]}`;
                valueEnd = `${valueEnd.toISOString().split("T")[0]}`;
                weeks.push({text: weekText, value:`${valueStart}|${valueEnd}`, active:active});
                active = false;
            }else{
                // let weekText = `${this.alwaysTwoDigits(current.getDate())}/${this.months[current.getMonth()]}`;
                let weekText = this.dateFormatLocal(current);
                valueStart = current;
                current = this.getLastDayOfMonth(current.getFullYear(), current.getMonth())
                // weekText += ` - ${this.alwaysTwoDigits(current.getDate())}/${this.months[current.getMonth()]}`;
                weekText += ` - ${this.dateFormatLocal(current)}`;
                valueEnd = current;

                if(now >= valueStart && now <= valueEnd)
                    active = true;

                // const fullMonth = (valueStart.getMonth()+1) <= 9 ? `0${valueStart.getMonth()+1}`: valueStart.getMonth()+1;
                valueStart = `${valueStart.toISOString().split("T")[0]}`;
                valueEnd = `${valueEnd.toISOString().split("T")[0]}`;
                weeks.push({text: weekText, value:`${valueStart}|${valueEnd}`, active:active});
                active = false;
                
            }
            current = current.addDays(1);

            if(current > end)
                broke = true;
        }
        return weeks;
    }

    weeksYear(year)
    {
        let start = new Date(`${year}-01-01`);
        start.setHours(0,0,0,0);
        let end = new Date(`${year}-12-31`);
        end.setHours(0,0,0,0)

        let now = new Date();
        now.setHours(0,0,0,0)
        let broke = false;
        const weeks = [];
        let current = start;
        let valueStart = null;
        let valueEnd = null;
        let active = false;

        while (!broke) {
            
            //monday first day
            if(current.getDay() == 1){
                let weekText = `${this.alwaysTwoDigits(current.getDate())}/${this.months[current.getMonth()]}`;
                valueStart = current;
                current = current.addDays(6);
                weekText += ` - ${this.alwaysTwoDigits(current.getDate())}/${this.months[current.getMonth()]}`;
                valueEnd = current;
                // console.log(now, valueStart, now >= valueStart, now <= valueEnd, this.checkBetweenDates(now.toJSON().slice(0,10), valueStart.toJSON().slice(0,10), valueEnd.toJSON().slice(0,10)));
                if(now >= valueStart && now <= valueEnd)
                    active = true;

                let moStart = new Intl.DateTimeFormat("es", { month: "2-digit" }).format(
                    valueStart
                );
                let daStart = new Intl.DateTimeFormat("es", { day: "2-digit" }).format(valueStart);

                let moEnd = new Intl.DateTimeFormat("es", { month: "2-digit" }).format(
                    valueEnd
                );
                let daEnd = new Intl.DateTimeFormat("es", { day: "2-digit" }).format(valueEnd);

                valueStart = `${valueStart.getFullYear()}-${moStart}-${daStart}`;
                valueEnd = `${valueEnd.getFullYear()}-${moEnd}-${daEnd}`;
                weeks.push({text: weekText, value:`${valueStart}|${valueEnd}`, active:active});
                active = false;
            }
            current = current.addDays(1);

            if(current > end)
                broke = true;
        }
        return weeks;
    }

    weeksYearFullFormat(year)
    {
        let start = new Date(`${year}-01-01`);
        start.setHours(0,0,0,0);
        let end = new Date(`${year}-12-31`);
        end.setHours(0,0,0,0)

        let now = new Date();
        now.setHours(0,0,0,0)
        let broke = false;
        const weeks = [];
        let current = start;
        let valueStart = null;
        let valueEnd = null;
        let active = false;

        while (!broke) {
            
            //monday first day
            if(current.getDay() == 1){
                // let weekText = `${this.alwaysTwoDigits(current.getDate())}/${this.months[current.getMonth()]}`;
                valueStart = current;
                current = current.addDays(6);
                // weekText += ` - ${this.alwaysTwoDigits(current.getDate())}/${this.months[current.getMonth()]}`;
                valueEnd = current;
                // console.log(now, valueStart, now >= valueStart, now <= valueEnd, this.checkBetweenDates(now.toJSON().slice(0,10), valueStart.toJSON().slice(0,10), valueEnd.toJSON().slice(0,10)));
                if(now >= valueStart && now <= valueEnd)
                    active = true;

                let moStart = new Intl.DateTimeFormat("es", { month: "2-digit" }).format(
                    valueStart
                );
                let daStart = new Intl.DateTimeFormat("es", { day: "2-digit" }).format(valueStart);

                let moEnd = new Intl.DateTimeFormat("es", { month: "2-digit" }).format(
                    valueEnd
                );
                let daEnd = new Intl.DateTimeFormat("es", { day: "2-digit" }).format(valueEnd);

                valueStart = `${valueStart.getFullYear()}-${moStart}-${daStart}`;
                valueEnd = `${valueEnd.getFullYear()}-${moEnd}-${daEnd}`;
                weeks.push({
                    text: `${Utils.globalDateFormat(valueStart)} - ${Utils.globalDateFormat(valueEnd)}`, 
                    value:`${valueStart}|${valueEnd}`, 
                    active:active
                });
                active = false;
            }
            current = current.addDays(1);

            if(current > end)
                broke = true;
        }
        return weeks;
    }

    getISOWeeksOfYear(year, useWTHFunction = true) {
        const weeks = [];

        // Get the current day
        const today = new Date();
        today.setHours(0,0,0,0)

        // Get the date of the first Monday of the ISO year
        const firstThursday = new Date(Date.UTC(year, 0, 4)); // Jan 4
        const dayOfWeek = firstThursday.getUTCDay() || 7; // Sunday=0 → make 7
        const firstMonday = new Date(firstThursday);
        firstMonday.setUTCDate(firstThursday.getUTCDate() - (dayOfWeek - 1));

        let currentMonday = firstMonday;
        let weekNumber = 1;

        while (currentMonday.getUTCFullYear() <= year) {
            const start = new Date(currentMonday);

            const end = new Date(currentMonday);
            end.setUTCDate(end.getUTCDate() + 6); // +6 days → Sunday

            // Only include weeks that belong to the target ISO year
            if (start.getUTCFullYear() === year || end.getUTCFullYear() === year) {
                weeks.push({
                    text: `${Utils.globalDateFormat(start.toISOString().slice(0, 10))} - ${Utils.globalDateFormat(end.toISOString().slice(0, 10))}`, 
                    week: weekNumber,
                    start: start.toISOString().slice(0, 10),
                    end: end.toISOString().slice(0, 10),
                    active: today >= start && today <= end
                });
            }

            // Move to next week
            currentMonday = new Date(currentMonday);
            currentMonday.setUTCDate(currentMonday.getUTCDate() + 7);

            weekNumber++;
        }
        if(useWTHFunction)
            return this.wthProcess(weeks, year)
        return weeks;
    }

    wthProcess(data, year){
      
        //si hay fecha del siguiente year entonces se quita
        let lastWeek = data[data.length-1];
        //console.log//(lastWeek,lastWeek.end.includes(year+1))
        if(lastWeek.end.includes(year+1)){
            data.splice(data.length-1,1)
        }
        
        //obtener el year pasado y ver si tiene year actual, si entonces se pone en top
        let oldYearWeek = this.getISOWeeksOfYear(year - 1, false);
        oldYearWeek = oldYearWeek[oldYearWeek.length-1];
        if(oldYearWeek.end.includes(year)){
            const found = data.find((x) => x.start == oldYearWeek.start && x.end == oldYearWeek.end);
            if(found == undefined){
                data = [oldYearWeek,...data];
                data.forEach((item,i) => {
                    item.week = i + 1;
                });
            }
        }
        return data;

    }

    static sortObjectArray(data, by){
        if(data == null) return data;

        // if(Object.hasOwn(data, 'incomes')){
        //     data.incomes.data.incomes = data?.incomes?.data?.incomes.sort((a, b) => b[by].localeCompare(a[by]))??[];
        //     data.incomes.data.other_incomes = data?.incomes?.data?.other_incomes?.sort((a, b) => b[by].localeCompare(a[by]));

        // }


        // Object.keys(data?.expenses?.data).forEach(key => {
        //     data.expenses.data[key] = data.expenses.data[key].sort((a, b) => b[by].localeCompare(a[by]));
        // });
        return data.sort((a, b) => b[by].localeCompare(a[by])).reverse();
    }

    static createFilter(options, headers, defaultSort = null)
    {   
        let sortBy = '';
        let sortDesc = false;
        let itemsPerPage = '10';
        let search = '';

        if(options?.itemsPerPage){
            itemsPerPage = options.itemsPerPage;
        }
        if(isNaN(options.page))
            options.page = 1;

        if(options?.sortBy?.length >= 1){
            sortBy = options.sortBy[0];
        }
        if(defaultSort != null){
            sortBy = defaultSort;
        }
        if(options?.sortDesc?.length >=1){
            sortDesc = options.sortDesc[0]; 
        }

        if(options?.search != undefined && options?.search != ''){
           
            search = options.search;
        }

        let headersString = '';
        headers.forEach(h => {
            headersString += `&columns[]=${h.value}`;
        });

        // return {search, page: options.page, itemsPerPage, sortBy, sortDesc}
        return `?page=${options.page}&itemsPerPage=${itemsPerPage}&sortBy[]=${sortBy}&sortDesc[]=${sortDesc}${search != '' ? `&search=${search}` : ''}${headersString}`;
    }

    //format > dd/mm/yyyy
    static globalDateFormat(data) {
        if(data == null)
            return "-";
        const new_date = new Date(data);
        if (new_date instanceof Date && !isNaN(new_date)) {
          let dateArray = new Array();
          dateArray[0] = data.substring(0, 4);
          dateArray[1] = data.substring(5, 7);
          dateArray[2] = data.substring(8, 10);
  
          let date = new Date(dateArray[0], dateArray[1] - 1, dateArray[2]);
  
          let ye = new Intl.DateTimeFormat("es", { year: "numeric" }).format(
            date
          );
          let mo = new Intl.DateTimeFormat("es", { month: "2-digit" }).format(
            date
          );
          let da = new Intl.DateTimeFormat("es", { day: "2-digit" }).format(date);
          let newDate = `${da}/${mo.charAt(0).toUpperCase() + mo.slice(1)}/${ye}`;
          return newDate;
        }
        return "-";
    }

    static getPercentage(value, total){
        if(value == '' || value == undefined || value == 0) return "-"
        if(total == '' || total == undefined || total == 0) return "-"
        return (value/total) *100;
    }

    static getIvaValue(value, iva = 0.16){
        if(value == undefined || value == null ||value == '') return 0;

        return (value * iva).toFixed(2);
    }

    dateFormatLocal(data) {
        const new_date = data;
        if (new_date instanceof Date && !isNaN(new_date)) {
          
  
          let date = data;
  
          let ye = new Intl.DateTimeFormat("es", { year: "numeric" }).format(
            date
          );
          let mo = new Intl.DateTimeFormat("es", { month: "2-digit" }).format(
            date
          );
          let da = new Intl.DateTimeFormat("es", { day: "2-digit" }).format(date);
          let newDate = `${da}/${mo.charAt(0).toUpperCase() + mo.slice(1)}/${ye}`;
          return newDate;
        }
        return new_date;
    }

    static currencyFormat(money, _currency = "MXN", fractionDigits = 2) {
        //console.log(money);
        // const currency = parseFloat(money).toFixed(2);
        const formatter = new Intl.NumberFormat("es-MX", {
          style: "currency",
          currency: "MXN",
          minimumFractionDigits: fractionDigits,
        });
        return formatter.format(money)+" " + _currency;
    }

    /**
     * Get the same day of le last month
     * if day doesnt exist then returns the last day of last month
     * @returns {Date}
     */
    static getStartDate()
    {
        let actual = new Date();
        let month = (actual.getMonth() + 1) - 1;
        let year = actual.getFullYear();
        let day = actual.getDate();
        
        //set to december
        if(month == 0){
            month = 12;
            year = year - 1;
        }

        let start = new Date(`${month}-${day}-${year} 00:00:00`);

        //set to last day of past month
        if(actual.getDate() != start.getDate()){
            var d = new Date(year, month, 0);
            return d.toISOString().split('T')[0];
        }

        //same day but past month
        return start.toISOString().split('T')[0];
    } 


    static getIndexArrayObject(array, field, value)
    {
        return array.map(e => e[field]).indexOf(value);
    }


    /**
     * Removes first word from a string
     * @param {string} phrase 
     * @returns {string} phrase without first word
     */
    static deleteFirstWord(phrase)
    {
        let spplited = phrase.split(" ");
        spplited.shift();
        return spplited.join(' ');
        
    }

    /**
     * Set page scroll to top.
     */
    static scrollToTop()
    {
        window.scrollTo(0,0);
    }

    /**
     * Capitalize first letter of every word
     * @param {string} phrase 
     * @returns {string} 
     */
    static capitalizePhrase(phrase)
    {
        return phrase.replace(/(^\w|\s\w)/g, m => m.toUpperCase());
    }

    /**
     * Returns phrase without a selected word.
     * @param {string} word word to delete
     * @param {string} phrase phrase base
     * @returns {string} new phrase
     */
    static deleteWord(word, phrase)
    {
        //console.log(word, phrase);
        return phrase.replaceAll(word, '');
    }

    /**
     * Check if an object has properties
     * @param {object} obj object to check
     * @returns {boolean}
     */
    static objectIsEmpty(obj) {
        if(typeof obj == 'string')
            return true;
        return Object.keys(obj).length === 0;
    }

    /**
     * Returns date in selected time zone
     * @param {*} date date string | Date
     * @param {string} tzString timeZone
     * @returns {Date}
     */
    static convertTZ(date, tzString) {
        return new Date((typeof date === "string" ? new Date(date+' 00:00:00') : date).toLocaleString("en-US", {timeZone: tzString}));   
    }


    /**
     * Returns the object's value from a path
     * @param {object} obj 
     * @param {string} path 
     * @returns value
     */
    static getObjectValue(obj, path) {
        if (!path) return obj;
        const properties = path.split('.');
        try {
            return this.getObjectValue(obj[properties.shift()], properties.join('.'))
        } catch (error) {
            return null;
        }
        //return this.getObjectValue(obj[properties.shift()], properties.join('.'))
    }

    /**
     * Trim a string at a length and adds "..." at the end.
     * @param {string} input string
     * @param {number} length 
     * @returns {string}
     */
    static trimStringAt(input, length = 25)
    {
        return input.length > length ? input.substring(0, length - 3) + "...":input;
    }

    /**
     * HEX TO RGB color conversion. 
     * @param {string} hex hex color code
     * @returns rgb object
     */
    static hexToRgb(hex) {
        var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        return result ? {
          r: parseInt(result[1], 16),
          g: parseInt(result[2], 16),
          b: parseInt(result[3], 16)
        } : null;
    }


    static getYearsSelects(selectedYear = "")
    {
        let years = [];
        let now = new Date();
        now.setHours(0,0,0,0)
        const year = now.getFullYear();
        if(selectedYear == "")
            selectedYear = ""+year;
        for (let i = 2025; i <= year; i++) {
            years.push({text: ""+i, value: ""+i});
        }

        return {years, selectedYear};
    }
}


Date.prototype.addDays = function(days) {
    var date = new Date(this.valueOf());
    date.setDate(date.getDate() + days);
    return date;
}